import { createContext, useContext } from 'react';

export const AuthContext = createContext();

/**
 * @return {{authTokens: string, setAuthTokens: (any) => void, removeAuthTokens: () => void}}
*/
export function useAuth() {
    return useContext(AuthContext);
}